module.exports = __webpack_public_path__ + "static/media/React-icon.248d9a3d.png";